<template>
  <section class="content">
    <div class="row center-block">
      <div
        v-if="getRoleType === 99"
        class="col-xs-12 p-x-0 m-b-10 flex align-center"
      >
        <router-link :to="{
          name: goBackInfo.name,
          params: goBackInfo.params,
          query: goBackInfo.query
        }">
          <div class="btn btn-default m-r-5 flex">
            <span>返回</span>
            <span v-text="goBackInfo.title" />
            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <ul class="nav nav-tabs" style="margin-bottom: 10px;">
              <li role="presentation" :class="{'active': scheduleMethod == 1}" @click="scheduleMethod = 1">
                <a>菜單
                </a>
              </li>
              <li role="presentation" :class="{'active': scheduleMethod == 2}" @click="scheduleMethod = 2" v-if="getRoleType !== 10 && !isStore">
                <a>各店
                </a>
              </li>
            </ul>
            <div class="row form-inline">
              <div class="col-sm-6 text-left form-group">
                <div class="form-group inline-block">
                  <select class="form-control h-38" v-model="statusSelect">
                    <option v-for="status in statusList" :value="status.value">
                      {{ status.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6 text-right" v-if="scheduleMethod === 2">
                <div class="form-group">
                  <select class="form-control h-38">
                    <option value="1">門市ID</option>
                  </select>
                </div>
                <div class="form-group search-bar">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="searchStoreId">
                    <span class="input-group-addon c-pointer" @click="getList(1)"><i class="fa fa-search"></i></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 table-responsive p-x-0">
              <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                <thead>
                <tr role="row">
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="scheduleMethod === 2 || store.name">分店(ID)</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">菜單 (ID)</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">名稱</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">版本碼</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">狀態</th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">
                    {{ scheduleMethod === 1 ? '上架時間' : '上架區間' }}
                  </th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                  <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                </tr>
                </thead>
                <tbody>
                  <tr class="even" role="row" v-for="(menu, index) in scheduleList">
                    <!-- cloumn 0 -->
                    <td class="sorting_1">{{index + 1}}</td>
                    <!-- column 1-->
                    <td v-if="scheduleMethod === 2 || store.name">
                      {{menu.store_name || store.name}} ({{menu.store_id}})
                    </td>
                    <td>
                      {{menu.menu_src_id || '-'}}
                    </td>
                    <!-- column 2-->
                    <td>
                      {{menu.menu_name}}
                    </td>
                    <!-- menu_ver_stamp -->
                    <td>
                      {{menu.menu_ver_stamp}}
                    </td>
                    <!-- column 3-->
                    <td>
                      <div :class="[
                        'status',
                        { 'status-default':  menu.status === 3 },
                        { 'status-success':  menu.status === 4 },
                        { 'status-danger':  menu.status === 5 },
                      ]">
                        {{ statusName(menu.status) }}
                      </div>
                    </td>
                    <!-- column 4-->
                    <td>
                      <span>{{getTime(menu.start_time)}}</span>
                      <span v-if="scheduleMethod === 2">~ {{getTime(menu.end_time)}}</span>
                    </td>
                    <!-- column middle-->
                    <td>
                      <button
                        v-if="scheduleMethod === 1 && menu.status !== 4"
                        class="btn btn-default"
                        @click="goToStoreMenuScheduleEdit({ menu, type: 1 })"
                      >
                        <i class="fa fa-pencil" />
                      </button>
                      <button
                        v-else-if="menu.status !== 4"
                        class="btn btn-default"
                        @click="goToStoreMenuScheduleEdit({ menu, type: 2 })"
                      >
                        <i class="fa fa-pencil" />
                      </button>
                    </td>
                    <td>
                      <div v-if="scheduleMethod === 1 || store.name">
                        <button
                          class="btn btn-danger"
                          v-if="menu.status === 4"
                          data-toggle="modal"
                          data-target="#removeGNowModal"
                          @click="curGroup = menu.group_id"
                        >
                          <span><i class="fa fa-arrow-circle-down"></i></span>
                          立即下架
                        </button>
                        <button
                          class="btn btn-success"
                          v-else-if="menu.status !== 5 || menu.is_expired !== 1"
                          data-toggle="modal"
                          data-target="#saleGNowModal"
                          @click="curGroup = menu.group_id"
                        >
                          <span><i class="fa fa-arrow-circle-up"></i></span>
                          立即上架
                        </button>
                      </div>
                      <div v-if="scheduleMethod === 2">
                        <button
                          class="btn btn-danger"
                          v-if="menu.status === 4"
                          data-toggle="modal"
                          data-target="#removeNowModal"
                          @click="curSchedule = menu.schedule_id"
                        >
                          <span><i class="fa fa-arrow-circle-down"></i></span>
                          立即下架
                        </button>
                        <button
                          class="btn btn-success"
                          v-else-if="menu.status !== 5 || menu.is_expired !== 1"
                          data-toggle="modal"
                          data-target="#saleNowModal"
                          @click="curSchedule = menu.schedule_id"
                        >
                          <span class="m-r-1"><i class="fa fa-arrow-circle-up"></i></span>
                          立即上架
                        </button>
                      </div>
                    </td>
                    <td>
                      <button
                        class="btn btn-danger"
                        v-if="menu.status !== 4"
                        data-toggle="modal"
                        data-target="#delModal"
                        @click="curGroup = menu.group_id"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-xs-12 text-center">
              <ul class="pagination">
                <li class="paginate_button" @click="clickEnd('pre')">
                  <a class="c-pointer"><i class="fa fa-step-backward" aria-hidden="true"></i></a>
                </li>
                <li class="paginate_button"  @click="clickGroup('left')">
                  <a class="c-pointer"><i class="fa fa-backward" aria-hidden="true"></i></a>
                </li>
                <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="clickPage(index)" v-if="pageShow(index)">
                  <a class="c-pointer">{{index}}</a>
                </li>
                <li class="paginate_button disabled" v-for="dis in (groupAmount - Math.ceil(pageAmount % 10))" v-if="pageGroup === Math.ceil(pageAmount / groupAmount)">
                  <a class="c-pointer">&nbsp;&nbsp;</a>
                </li>
                <li class="paginate_button" @click="clickGroup('right')">
                  <a class="c-pointer"><i class="fa fa-forward" aria-hidden="true"></i></a>
                </li>
                <li class="paginate_button" @click="clickEnd('forward')">
                  <a class="c-pointer"><i class="fa fa-step-forward" aria-hidden="true"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view />
    <m-modal :option="delOption" @trigger="trigger"></m-modal>
    <m-modal :option="removeGNowOption" @trigger="trigger"></m-modal>
    <m-modal :option="saleGNowOption" @trigger="trigger"></m-modal>
    <m-modal :option="removeNowOption" @trigger="trigger"></m-modal>
    <m-modal :option="saleNowOption" @trigger="trigger"></m-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'
import 'datatables.net'
import 'datatables.net-bs'
import storeListTemp from './Temp/StoreListTemp.vue'
import Multiselect from 'vue-multiselect'
import '../../../../static/vendor/Gantt/1.10.2/css/style.css'
import '../../../../static/vendor/Gantt/1.10.2/js/jquery.fn.gantt.js'
import matcherModal from '../../elements/Modal.vue'
import moment from 'moment'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'BrandScheduleTable',
  extends: NdExtendHandleMenu,
  components: {
    'storelist-table': storeListTemp,
    Multiselect,
    'm-modal': matcherModal
  },
  data () {
    return {
      searchStoreId: '',
      scheduleMethod: 1, // 1 = 菜單 ， 2 = 各店
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 12,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      statusSelect: 99,
      statusList: [
        {label: '全部', value: 99},
        {label: '上架中', value: 4},
        {label: '等待上架', value: 3},
        {label: '已下架', value: 5}
      ],
      menuList: [
        {store_id: 1, store_name: '長春店', menu_name: '夏日菜單', menu_id: '1', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'},
        {store_id: 1, store_name: '中山店', menu_name: '夏日菜單', menu_id: '1', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'},
        {store_id: 1, store_name: '雙連店', menu_name: '菜單B', menu_id: '3', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'},
        {store_id: 1, store_name: '光復店', menu_name: '菜單A', menu_id: '2', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'},
        {store_id: 1, store_name: '民權西路店', menu_name: '菜單B', menu_id: '3', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'},
        {store_id: 1, store_name: '晶華店', menu_name: '菜單C', menu_id: '4', status: 3, start_time: '2018/01/01', end_time: '2018/12/31'}
      ],
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [],
      scheduleList: [],
      curGroup: '',
      curSchedule: '',
      delOption: {
        id: 'delModal',
        title: '刪除檔期群組',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delGroup'
          }
        ]
      },
      removeGNowOption: {
        id: 'removeGNowModal',
        title: '檔期群組下架',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'removeGNow'
          }
        ]
      },
      saleGNowOption: {
        id: 'saleGNowModal',
        title: '檔期群組上架',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'saleGNow'
          }
        ]
      },
      removeNowOption: {
        id: 'removeNowModal',
        title: '店家檔期下架',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'removeNow'
          }
        ]
      },
      saleNowOption: {
        id: 'saleNowModal',
        title: '店家檔期上架',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'saleNow'
          }
        ]
      }
    }
  },
  mounted () {
    this.getExtendHandleMenuInfo()
  },
  methods: {
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    getTime (time) {
      if (time) {
        return moment(time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
      }
    },
    trigger (event) {
      if (event === 'delGroup') {
        this.delGroup()
      } else if (event === 'removeGNow') {
        this.removeGNow()
      } else if (event === 'saleGNow') {
        this.saleGNow()
      } else if (event === 'removeNow') {
        this.removeNow()
      } else if (event === 'saleNow') {
        this.saleNow()
      }
    },
    statusName (type) {
      switch (type) {
        case 3:
          return '等待上架'
        case 4:
          return '上架中'
        case 5:
          return '已下架'
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    editStores (menuId) {
      this.$router.push('/upSchedule/all/' + menuId)
    },
    clickPage (index) {
      this.tableIndex = index
      this.getList()
    },
    getScheduleGroupList (page) {
      if (page) this.tableIndex = page
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      let url = this.base + this.id + '/menu/schedule/group/list?page=' + data.page + '&size=' + data.size + '&sortby=start_time DESC'
      if (this.statusSelect !== 99 && this.statusSelect) url = url + '&status=' + this.statusSelect
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.total = response.data.meta.total
          const sList = response.data.menu_schedule_group_list
          this.scheduleList = sList
        }
      })
    },
    getScheduleList (page) {
      var self = this
      if (page) this.tableIndex = page
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      let url = this.base + this.id + '/menu/schedule/list?page=' + data.page + '&size=' + data.size + '&sortby=start_time DESC'
      if (self.statusSelect !== 99 && self.statusSelect) url = url + '&status=' + self.statusSelect
      if (self.searchStoreId) url = url + '&store_id=' + self.searchStoreId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.total = response.data.meta.total
          const sList = response.data.menu_schedule_list
          self.scheduleList = sList
        }
      })
    },
    checkDoubleStore (storeIdList) {
      var newScheduleList = []
      for (let key in storeIdList) {
        if (storeIdList[key].length === 1) {
          newScheduleList.push(storeIdList[key][0])
        } else {
          var combineSchedule = {}
          for (let i = 0; i < storeIdList[key].length; i++) {
            if (i === 0) {
              combineSchedule = storeIdList[key][i]
            } else {
              combineSchedule.values.push(storeIdList[key][i].values[0])
            }
          }
          newScheduleList.push(combineSchedule)
        }
      }
      this.setGantt(newScheduleList)
    },
    setGantt (scheduleList) {
      var self = this
      if (scheduleList.length) {
        $('.gantt').gantt({
          source: scheduleList,
          scale: 'months',
          minScale: 'months',
          navigate: 'scroll',
          waitText: '正在讀取菜單排程...',
          itemsPerPage: 12,
          onItemClick (data) {
            self.$router.push({path: '/storeScheduleTable/' + self.$route.params.brand_id + '/' + data.store_id})
            // console.log(data)
          }
        })
        $('.gantt').css('display', 'block')
        $('menu-info').css('display', 'block')
      } else {
        $('.gantt').css('display', 'none')
        $('menu-info').css('display', 'none')
      }
    },
    removeGNow () {
      var self = this
      const url = this.base + this.id + '/menu/schedule/group/' + self.curGroup + '/removenow'
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '下架成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getScheduleGroupList()
        }
      })
    },
    saleGNow () {
      var self = this
      const url = this.base + this.id + '/menu/schedule/group/' + self.curGroup + '/salenow'
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '上架成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getScheduleGroupList()
        }
      })
    },
    removeNow () {
      var self = this
      const url = this.base + this.id + '/menu/schedule/' + self.curSchedule + '/removenow'
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '下架成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getScheduleList()
        }
      })
    },
    saleNow () {
      var self = this
      const url = this.base + this.id + '/menu/schedule/' + self.curSchedule + '/salenow'
      this.getDataH('put', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '上架成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getScheduleList()
        }
      })
    },
    delGroup () {
      var self = this
      const url = this.base + this.id + '/menu/schedule/group/' + self.curGroup
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '提醒',
            text: '刪除成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          if (self.scheduleMethod === 1) {
            self.getScheduleGroupList()
          } else {
            self.getScheduleList()
          }
        }
      })
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    getList (page) {
      if (page) {
        if (this.scheduleMethod === 1) this.getScheduleGroupList(1)
        else this.getScheduleList(1)
      } else {
        if (this.scheduleMethod === 1) this.getScheduleGroupList()
        else this.getScheduleList()
      }
    },
    goToStoreMenuScheduleEdit ({ menu = {}, type = 0 }) {
      console.log('goToStoreMenuScheduleEdit', menu)
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      }

      if (this.isStore && this.getRoleType !== 10) {
        if (type === 1) {
          name = 'StoreMenuScheduleEditG'
          params.group_id = menu.group_id
        }
        if (type === 2) {
          name = 'StoreMenuScheduleEditS'
          params.schedule_id = menu.schedule_id
        }
        params.store_id = this.$route.params.store_id
      } else {
        if (type === 1) {
          name = 'upSchedule'
          params.group_id = menu.group_id
        }
        if (type === 2) {
          name = 'upStoreSchedule'
          params.schedule_id = menu.schedule_id
        }
      }

      this.$router.push({ name, params })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    scheduleListNew () {
      var menuList = {}
      var oldList = this.menu_schedule_list
      for (var key in oldList) {
        // console.log(oldList[key].menu_id)
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        }
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id,
          menu_id: oldList[key].menu_id
        })
      }
      return menuList
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    statusSelect () {
      this.getList()
    },
    menuState () {
      this.tableIndex = 1
      this.pageGroup = 1
    },
    scheduleMethod () {
      this.tableIndex = 1
      this.pageGroup = 1
      this.getList(1)
      window.sessionStorage.setItem('Nidin_scheduleTable_method', this.scheduleMethod)
    }
  },
  created () {
    var method = window.sessionStorage.getItem('Nidin_scheduleTable_method')
    if (method) this.scheduleMethod = parseInt(method, 10)
    if (this.scheduleMethod === 1) this.getScheduleGroupList()
    else this.getScheduleList()
  }
}
</script>
<style lang="sass">
.gantt
  border: 2px solid #ddd
.menu-info
  min-height: 120px
  width: 100%
  text-align: center
  *
    padding: 0
    margin: 0
    line-height: 25px
.m-b-15
  margin-bottom: 15px !important
.btn-edit-all, .btn-del-all
  margin-right: 15px
  z-index: 100
.nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
  display: none !important
.fn-gantt .leftPanel
  width: 100px !important
.fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
  font-size: 14px
.fn-gantt .navigate
  padding: 10px 0 10px 10px !important
@media screen and (max-width: 499px)
  .min-m-t-10
    margin-top: 25px
.status
  display: inline-block
  min-width: 10px
  padding: 5px 10px
  color: #fff
  border-radius: 4px
  font-size: 14px
  &.status-default
    background-color: gray
    border-color: gray
  &.status-success
    background-color: #00a65a
    border-color: #008d4c
  &.status-danger
    background-color: #dd4b39
    border-color: #d73925
</style>



// WEBPACK FOOTER //
// BrandScheduleTable.vue?1824a4e5